export const HEIGHT_GRID_LOGO = 80;
